import { IsInt, IsOptional, IsString } from "class-validator";

import "reflect-metadata";

export class UserMetadata {
  @IsString()
  @IsOptional()
  language?: string;

  @IsString()
  @IsOptional()
  dateFormat?: string;

  @IsString()
  @IsOptional()
  timeFormat?: string;

  @IsString()
  @IsOptional()
  isMustChangePassword?: string;

  @IsString()
  @IsOptional()
  defOrderTypeIid?: string;
}

export class UserRole {
  @IsOptional()
  @IsInt()
  id?: number;

  @IsOptional()
  @IsInt()
  companyId?: number;

  @IsInt()
  oldId?: number;

  @IsString()
  oldType: string;

  @IsInt()
  userId?: number;

  @IsOptional()
  @IsInt()
  roleId?: number;
}

export interface IUserDto {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  remarks: string;
  metadata: UserMetadata;
  password: string;
  userRoles?: UserRole[];
}
